import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import ScheduleSessionCard from "./ScheduleSessionCard";
import Loader from "../ui/Loader";
import EmptyBlock from "../ui/EmptyBlock";
import axios from "axios";
import routes from "../../app/routes";

export default function ScheduleNewSessions() {
  const [items, setItems] = useState([]);
  const [pageCount, setpageCount] = useState(0);
  let [loader, setLoader] = useState(true);

  const updateItems = (page) => {
    axios
      .get(routes.api.users.schedule_new_sessions, { params: { page } })
      .then((resp) => {
        const data = resp.data;
        setItems(data.data);
        setpageCount(data.count);
        setLoader(false);
      });
  };

  const handlePageClick = (data) => {
    updateItems(data.selected + 1);
  };

  useEffect(() => {
    updateItems(1);
  }, []);

  return (
    <>
      <Loader state={loader} />
      {!loader && (
        <>
          {items.length == 0 && (
            <EmptyBlock text="You have no sessions to schedule" />
          )}
          {items.length > 0 && (
            <>
              <div className="row">
                {items.map((value, index) => {
                  return (
                    <div key={index} className="col-md-6">
                      <ScheduleSessionCard {...value.attributes} />
                    </div>
                  );
                })}
              </div>
              {pageCount > 1 && (
                <div className="paginate-wrapper">
                  <ReactPaginate
                    previousLabel={<i className="fa fa-angle-left"></i>}
                    nextLabel={<i className="fa fa-angle-right"></i>}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
